import React from 'react'
import { useHistory } from 'react-router-dom';
import 'antd/dist/antd.css';
import { Button } from 'antd';
import './PaymentPolicy.css'


const PaymentPolicy = () => {

    const history = useHistory();
    return (
        <div className="App">
            <div className='bx-policy'>
                <h1 className='title-policy'>ข้อตกลงและเงื่อนไขการชำระเงิน</h1>
                <p className='date-up'>Updated at 2022-01-01</p>

                <p className='des-policy'>ท่านตกลงที่จะปฏิบัติตามแนวปฏิบัติ คำสั่ง ระเบียบการดำเนินงาน นโยบายและคำแนะนำทั้งหลายเกี่ยวกับการสั่งซื้อสินค้าผ่านแพลตฟอร์ม รวมถึงการแก้ไขเพิ่มเติมใดๆในสิ่งที่กล่าวมาข้างต้นซึ่งออกใช้บังคับโดยทางเรา และถือว่าท่านได้รับทราบและยอมรับข้อผูกพันตามการเปลี่ยนแปลงดังกล่าวเมื่อมีการเผยแพร่บนแพลตฟอร์มแล้ว โดยข้อตกลงและเงื่อนไขการชำระเงินนี้จะมีผลบังคับใช้ต่อคำสั่งซื้อสินค้าและการชำระเงินที่กระทำโดยท่านและผู้ขายเท่านั้น</p>

                <h3 className='definition'>การชำระเงินและการคืนเงิน</h3>

                <ul className='ul-list'>
                    <li className='li-list'>
                        <p className='list-definition'>ท่านตกลงที่จะชำระค่าสินค้าด้วยบัตรเครดิตหรือบัตรเดบิตที่สามารถใช้ชำระหนี้ตามกฎหมายได้</p>
                    </li>
                    <li className='li-list'>
                        <p className='list-definition'>ท่านยินยอมที่จะไม่ยกเลิกการชำระเงินในภายหลังเว้นเสียแต่ว่า การสั่งซื้อสินค้าระหว่างท่านและผู้ขายไม่เป็นไปตามข้อตกลง ไม่ได้รับการส่งมอบสินค้า หรือสินค้าที่ท่านได้รับมีลักษณะแตกต่างจากรายละเอียดที่ท่านได้รับจากผู้ขายอย่างมีนัยยะสำคัญตามแต่วิจารณญาณของผู้ขาย</p>
                    </li>
                    <li className='li-list'>
                        <p className='list-definition'>ท่านรับทราบถึงระเบียบการขอคืนเงินที่ชำระสำเร็จจะกระทำได้ต่อเมื่อผู้ขายยินยอมและเป็นผู้แจ้งความประสงค์ที่จะทำการคืนเงินเท่านั้น</p>
                    </li>
                    <li className='li-list'>
                        <p className='list-definition'>ท่านรับทราบถึงการคืนเงินทั้งหลายให้ทำผ่านกลไลการชำระเงินเดิมและให้แก่บุคคลที่ทำการชำระเงินนั้น</p>
                    </li>
                    <li className='li-list'>
                        <p className='list-definition'>ท่านรับทราบถึงการไม่รับประกันเงินคืนจะเข้าสู่บัญชีของท่านอย่างตรงต่อเวลา การดำเนินการชำอาจจะใช้เวลาและขึ้นกับแต่ละธนาคาร และ/หรือผู้ให้บริการการชำระเงินที่ดำเนินการคืนเงินนั้น</p>
                    </li>
                </ul>
            </div>
            <div className='cov-btn-back'>
                <Button className='btn-back' onClick={()=>{
                    history.push("/wallets")
                }}>ย้อนกลับ</Button>
            </div>

        </div>
    )
}


export default PaymentPolicy
